import React from 'react'
import { manufacturerList } from '@/test_data/sample-supplier-manufacturer-data'
import { MiniAppText } from '@/ui/molecules/mini-app-text'
import { MiniAppProps } from './types'
import { useTabData } from '@sourcepilot/ui/framework/state/session-data';
import { ManufacturerData } from '@/types/organisation';

export function SuppliersMiniApp({ containerWidth }: MiniAppProps) {
  const [hoveredItem, setHoveredItem] = React.useState<string | null>(null);
  const { activeTab, navigateToTab } = useTabData();

  return (
    <div className="px-4">
      <ul className="p-0 list-none" >
        {manufacturerList.map((supplier: ManufacturerData) => (
          <li key={supplier.slug} className="p-auto m-auto leading-none" >
            <button 
              className="text-left hover:underline w-full"
              onClick={() => navigateToTab({
                id: supplier.slug,
                title: supplier.name,
                contentType: 'organisation',
              })}
              onMouseEnter={() => setHoveredItem(supplier.slug)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <MiniAppText 
                className="text-sm" 
                containerWidth={containerWidth - 32}
                // isActive={supplier.pathname === activeTab?.pathname}
                // isHovered={supplier.pathname === hoveredItem}
              >
                {supplier.name}
              </MiniAppText>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

